namespace RecordShield.Modules.Workspace.ContentKeys {
    export interface ContentKeyRequest extends Serenity.ServiceRequest {
        UserId?: number;
        ProductId?: number;
        Quantity?: number;
    }
}
